import { createSelector } from "reselect";
import { IRootState } from "../../app/types/rootReducers.t";

const moduleSelector = (state: IRootState) => state.withdrawal;

export const getPayoutAvailableMethods = createSelector(
    moduleSelector, state => state.payoutAvailableMethods,
);

export const getPayoutForm = createSelector(
    moduleSelector, state => state.payoutForm,
);

export const getPayoutParams = createSelector(
    moduleSelector, state => state.payoutParams,
);

export const getPayoutParamsSent = createSelector(
    moduleSelector, state => state.payoutParamsSent,
);

export const getPayoutLastDeposit = createSelector(
    getPayoutParams, state => state.lastDeposit,
);

export const getPayoutLastCompletedDeposit = createSelector(
    getPayoutParams, state => state.lastCompletedDeposit,
);

export const getWithdrawalPhase = createSelector(
    moduleSelector, state => state.phase,
);

export const getIsWithdrawalInited = createSelector(
    moduleSelector, state => state.isInited,
);

export const getWithdrawalTransferParams = createSelector(
    moduleSelector, state => state.transferParams,
);

export const getWithdrawalTransferTransactionUuid = createSelector(
    getWithdrawalTransferParams, transferParams => transferParams.transactionUuid,
);

export const getPayoutSelectedMethod = createSelector(
    moduleSelector, state => state.payoutSelectedMethod,
);

export const getWithdrawalError = createSelector(
    moduleSelector, state => state.error,
);

export const getIsWithdrawalCreateLoading = createSelector(
    moduleSelector, state => state.isCreateLoading,
);
